import { Amplify } from "@aws-amplify/core";
// Register Auth before configuring Core without loading unused Amplify categories.
import "@aws-amplify/auth";
import { VRSConst } from "../app/Constants";
import { getCookieStorageDomain } from "../utils/cognitoCookieUtils";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname.endsWith(".localhost");

Amplify.configure({
  Auth: {
    region: VRSConst.awsRegion,
    userPoolId: VRSConst.cognitoUserPoolId,
    userPoolWebClientId: VRSConst.cognitoClientId,
    oauth: {
      domain: `${VRSConst.cognitoDomainId}.auth.${VRSConst.awsRegion}.amazoncognito.com`,
      scope: ["openid", "email"],
      redirectSignIn: `${VRSConst.authPage}/callback`,
      redirectSignOut: `${VRSConst.authPage}/logout`,
      responseType: "code",
    },

    cookieStorage: {
      domain: getCookieStorageDomain(),
      path: "/",
      expires: 1,
      sameSite: "lax",
      secure: !isLocalhost, // Only use secure flag in production/QA (HTTPS required)
    },
  },
});

export default Amplify;
